export class SyncDecorator {
    public static onlyFireAfterDelayInBeingCalled(delayInMilliseconds: number) {
        if (!delayInMilliseconds) {
            throw new Error(
                'SyncDecorator.onlyFireAfterDelayInBeingCalled requires delayInMilliseconds'
            );
        }

        return function (_target: any, _name: string, property: any) {
            const fn = property.value;
            let timer: number;
            property.value = function (...args: any[]) {
                if (timer) {
                    clearTimeout(timer);
                }
                timer = window.setTimeout(() => {
                    const retVal = fn.apply(this, args);
                    if (retVal !== undefined) {
                        throw new Error(
                            'SyncDecorator.onlyFireAfterDelayInBeingCalled can only be applied to functions that do not return anything'
                        );
                    }
                }, delayInMilliseconds);
            };
        };
    }

    public static defer() {
        return this.onlyFireAfterDelayInBeingCalled(1);
    }
}
